import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const burnUpReportEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-next-gen-reports-burn-up-entrypoint" */ './src'),
	),
	getPreloadProps: () => ({}),
});
